export const img = (n) => `/img/mb300-${String(n).padStart(2, "0")}.jpg`;
export const GALLERY = Array.from({ length: 18 }, (_, i) => img(i + 1));
